import { Link } from "react-router-dom";
import { ArrowRight, BadgePoundSterling, Sparkles } from "lucide-react";

export const FastMonetisationDiscoveryBanner = ({
  source,
  rootTestId,
  ctaTestId,
  compact = false,
}) => (
  <div
    className="relative overflow-hidden border border-purple-500/35 bg-[#08050d]"
    data-testid={rootTestId}
  >
    <div className="absolute inset-y-0 right-0 w-2/5 bg-[linear-gradient(120deg,transparent,rgba(168,85,247,0.14))] pointer-events-none" />
    <div className={`relative grid grid-cols-1 items-center gap-6 md:grid-cols-12 ${compact ? "p-5 md:p-6" : "p-7 md:p-10"}`}>
      <div className="md:col-span-8">
        <div className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.28em] text-amber-300">
          <Sparkles size={12} /> Just dropped · Tracks 133–147
        </div>
        <h2 className={`mt-3 font-display font-black leading-tight text-white ${compact ? "text-2xl" : "text-3xl md:text-4xl"}`}>
          Fast-Monetisation Services
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-zinc-400 md:text-base">
          Fifteen productised service blueprints with target clients, realistic pricing, outreach, delivery systems and recurring-revenue paths.
        </p>
        <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-zinc-500">
          <span className="inline-flex items-center gap-1.5"><BadgePoundSterling size={13} className="text-purple-300" /> £120–£5,000+ offers</span>
          <span>180 operational prompts</span>
          <span>Included in Consulting</span>
        </div>
      </div>
      <div className="md:col-span-4 md:flex md:justify-end">
        <Link
          to={`/collections/fast-monetisation-services?ref=${source}`}
          className="inline-flex items-center gap-3 border border-purple-400 bg-purple-500 px-5 py-3 text-xs font-black uppercase tracking-[0.18em] text-black transition-[background-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:bg-purple-400 hover:shadow-[0_0_28px_rgba(168,85,247,0.45)]"
          data-testid={ctaTestId}
        >
          Explore all 15 <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  </div>
);